import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'

export interface ModalBibliographySearchResultAuthorityStoreInterface {
  onBackCondition?: () => void
  onSearch?: () => void
}

@Module({
  name: 'ModalBibliographySearchResultAuthorityStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalBibliographySearchResultAuthorityStore extends BaseStore {
  _isOpen: boolean = false

  _backConditionCallback?: () => void

  _searchCallback?: () => void

  get isOpen(): boolean {
    return this._isOpen
  }

  @Mutation
  public open(params?: ModalBibliographySearchResultAuthorityStoreInterface) {
    this._isOpen = true
    if (params) {
      this._backConditionCallback = params.onBackCondition
      this._searchCallback = params.onSearch
    }
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public search() {
    if (this._searchCallback) {
      this._searchCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public back() {
    if (this._backConditionCallback) {
      this._backConditionCallback()
    }

    this._isOpen = false
  }
}
